import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import { useDelete, useFetch, useFilter } from "../../../ApiS";
import { useParams } from "react-router-dom";
import Add from "../../Buttons/Add";
import { useState } from "react";
import { IoMdAdd } from "react-icons/io";
import PopUp from "../../PopUp";
import { Dialog } from "../../ui/Dialog";
import Search from "../../Search/Search";
import Table, { TableOperation } from "../../Table";
import { RiEditBoxFill } from "react-icons/ri";
import { FaEye, FaRegTrashAlt } from "react-icons/fa";
import { usePopUpsStore } from "../../../store/PopUpStore";
import Pagination from "../../pagination/Pagination (1)";
import PopUpDelete from "../../PopUps/PopUpDelete (1)";
import Loader from "../../Loader";

interface DiscountData {
  data: { data: Discount[]; last_page: number };
}

interface Discount {
  id: number;
  name: string;
  percentage: number;
  is_exhausted_student: boolean;
  semester_id: string;
}

export default function Discount() {
  const operations: TableOperation[] = [
    {
      name: "show",
      icon: FaEye,
      link: true,
      onClick: () => {
        console.log("View");
      },
    },
    {
      name: "edit",
      icon: RiEditBoxFill,
      link: true,
      onClick: () => {
        console.log("edit");
      },
    },
    {
      name: "delete",
      icon: FaRegTrashAlt,
      link: true,
      onClick: (id) => {
        setPopUpDelete([id, true]);
      },
    },
  ];
  const [create, setCreate] = useState<boolean>(false);
  const { setPopUpDelete, popUpDelete } = usePopUpsStore();

  const { id } = useParams();


  const { data, isLoading } = useFetch(
    `admin/semesters/${id}/discounts`,
    `discounts/${id}`
  );
  const { mutation, deleteItem } = useDelete(
    () => window.location.reload(),
    () => console.log(mutation.error)
  );

  return isLoading  ? (
    <Loader />
  ) : (
    <>
      <Row>
        <Col>
          <Title title="الخصومات" />
        </Col>
      </Row>
      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder=" اسم الخصم"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>
      <Row>
       
          <Table<Discount>
            tableHeads={[
              "رقم الفصل",
              "رقم الخصم",
              "اسم الخصم",
              " النسبة",
              "حالة الطالب",
              "العمليات",
            ]}
            tableBody={data?.data?.data}
            keys={[
              "semester_id",
              "id",
              "name",
              "percentage",
              "is_exhausted_student",
            ]}
            operations={operations}
            className="lg:min-w-[100px] md:min-w-[50px]"
          />
       
      </Row>
      {data?.data?.data?.length > 0 &&  <Pagination pageCount={data?.data?.last_page} /> }
      <PopUpDelete
        text="هل أنت متأكد من حذف هذا الخصم؟"
        onClickDelete={() => {
          deleteItem(`admin/semesters/${id}/discounts/${popUpDelete[0]}`);
          mutation.isLoading && <Loader />;
        }}
      />

      <Add link={`/new_semester/${id}/discounts`} />
    </>
  );
}
